export default "__VITE_ASSET__DjQ4mvq4__"